module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-checkbox', {
    staticClass: "compact",
    attrs: {
      "color": "primary",
      "input-value": _vm.value[_vm.schema.name],
      "label": _vm.schema.label,
      "hide-details": true,
      "hint": _vm.schema.hint,
      "placeholder": _vm.schema.placeholder,
      "outlined": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      }
    },
    nativeOn: {
      "mousedown": function($event) {
        return _vm.$emit('focus', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfe7c99e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/blocks/CheckboxControl.vue
// module id = 2651
// module chunks = 1